import * as React from "react";
import {cx} from "emotion";

import "./error-messages.scss";

export const ErrorMessages = ({disabled, translateError=v=>v.errorMessage, domRef, eh, validations}) => (
    <div
        className={cx("errors error-messages-6hn", {disabled: disabled || !validations.find((v) => v.hasError)}, eh?.css)}
        ref={domRef?.set}
    >
        {validations?.map((validation, i) => !!validation.hasError && (
            <div className="error" key={i} xd-qa-type="label" xd-qa-name="Validation Error">
                {translateError(validation)}
            </div>
        ))}
    </div>
);
